import { useMemo } from "react";

import usePermissions from "hooks/usePermissions";
import { getUnitSystemPreferences } from "@RequestFormV2/utils/getUnitSystemPreferences";

export function useUnitSystemPreferences() {
  const { permissions } = usePermissions();

  return useMemo(() => getUnitSystemPreferences(permissions), [permissions]);
}
